import getDefaultUserAgent from './get-default-user-agent';

// eslint-disable-next-line max-len
const mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const notMobileRE = /CrOS/;

const tabletRE = /android|ipad|playbook|silk/i;

type IsMobileProps = {
  includeTablets: boolean;
};

function isMobile(userAgent?: string, props?: IsMobileProps) {
  const agent = userAgent || getDefaultUserAgent();

  if (typeof agent !== 'string') {
    return false;
  }

  const result = (
    (mobileRE.test(agent) && !notMobileRE.test(agent))
    || (!!props?.includeTablets && tabletRE.test(agent))
  );

  return result;
}

export default isMobile;
